import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import Locales from '@axa-asia/hk-shared-utils/lib/locales';

addLocaleData(en);
addLocaleData(zh);

export default class Wrapper extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    locales: PropTypes.shape({
      en: PropTypes.object,
      zh: PropTypes.object,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    this.locales = new Locales({
      en: props.locales.en,
      zh: props.locales.zh,
    });
  }

  render() {
    const browserLang = this.props.lang; // Property tag html
    const messages = this.locales.getTranslations(browserLang);

    return (
      <Provider store={this.props.store}>
        <IntlProvider locale={this.locales.getReactIntlCode(browserLang)} messages={messages}>
          { this.props.children }
        </IntlProvider>
      </Provider>
    );
  }
}
